import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content nge-user-profile-content" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "email" }
const _hoisted_5 = { class: "nge-user-profile-grid" }
const _hoisted_6 = { class: "nge-user-profile-subgrid" }
const _hoisted_7 = { class: "nge-user-profile-count" }
const _hoisted_8 = { class: "nge-user-profile-count" }
const _hoisted_9 = { class: "nge-user-profile-count" }
const _hoisted_10 = { class: "nge-user-profile-subgrid" }
const _hoisted_11 = { class: "nge-user-profile-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    class: "userProfile",
    onHide: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "exit",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('hide')))
      }, "×"),
      _createElementVNode("div", _hoisted_1, [
        ($setup.sessions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString($setup.sessions[0].name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_4, _toDisplayString($setup.sessions[0].email), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "nge-user-profile-grid-header" }, "Edits", -1 /* HOISTED */)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "nge-user-profile-grid-header" }, "Cells", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "nge-user-profile-timespan" }, "Today", -1 /* HOISTED */)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "nge-user-profile-timespan" }, "Past 7 Days", -1 /* HOISTED */)),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "nge-user-profile-timespan" }, "All Time", -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_7, _toDisplayString($setup.userInfo.editsToday) + " (" + _toDisplayString($setup.userInfo.mergesToday) + " | " + _toDisplayString($setup.userInfo.splitsToday) + ")", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.userInfo.editsThisWeek) + " (" + _toDisplayString($setup.userInfo.mergesThisWeek) + " | " + _toDisplayString($setup.userInfo.splitsThisWeek) + ")", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.userInfo.editsAllTime) + " (" + _toDisplayString($setup.userInfo.mergesAllTime) + " | " + _toDisplayString($setup.userInfo.splitsAllTime) + ")", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "nge-user-profile-timespan" }, "Today", -1 /* HOISTED */)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "nge-user-profile-timespan" }, "Past 7 Days", -1 /* HOISTED */)),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "nge-user-profile-timespan" }, "All Time", -1 /* HOISTED */)),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "nge-user-profile-count" }, "0", -1 /* HOISTED */)),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "nge-user-profile-count" }, "0", -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_11, _toDisplayString($setup.cellsSubmitted), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}